import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, SearchIcon, PhoneIcon, GlobeIcon, UserIcon, ChevronDownIcon } from 'lucide-react';
import { MegaNavigation } from './MegaNavigation';
import { MobileNavigation } from './MobileNavigation';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  // Add scroll event listener to change header appearance
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <header className={`sticky top-0 z-30 transition-shadow duration-300 ${scrolled ? 'shadow-md' : ''}`} data-id="element-590">
      {/* Top bar */}
      <div className="bg-gray-900 text-white py-2 hidden md:block" data-id="element-591">
        <div className="container mx-auto px-4" data-id="element-592">
          <div className="flex justify-between items-center" data-id="element-593">
            <div className="flex items-center space-x-4" data-id="element-594">
              <a href="#" className="flex items-center text-sm hover:text-blue-300" data-id="element-595">
                <PhoneIcon size={16} className="mr-1" data-id="element-596" />
                <span data-id="element-597">+41 123 456 789</span>
              </a>
              <a href="#" className="flex items-center text-sm hover:text-blue-300" data-id="element-598">
                <GlobeIcon size={16} className="mr-1" data-id="element-599" />
                <span data-id="element-600">English</span>
                <ChevronDownIcon size={14} className="ml-1" data-id="element-601" />
              </a>
            </div>
            <div className="flex items-center space-x-6" data-id="element-602">
              <a href="#" className="text-sm hover:text-blue-300" data-id="element-603">
                Travel Essentials
              </a>
              <a href="/travel-club" className="text-sm hover:text-blue-300" data-id="element-604">
                Travel Club
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Main header with navigation */}
      <div className="bg-white" data-id="element-605">
        <div className="container mx-auto px-4" data-id="element-606">
          <div className="flex items-center justify-between h-20" data-id="element-607">
            {/* Left section: Logo and Navigation */}
            <div className="flex items-center" data-id="element-608">
              {/* Mobile menu button */}
              <button onClick={() => setMobileMenuOpen(true)} className="p-2 rounded-md text-gray-700 hover:text-blue-600 lg:hidden" aria-label="Open menu" data-id="element-609">
                <MenuIcon size={24} data-id="element-610" />
              </button>
              {/* Logo */}
              <a href="/" className="flex-shrink-0 flex items-center mr-6" data-id="element-611">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dGmrTFD4H9KRDNXV9TQzMi/image.png" alt="EU Holidays Logo" className="h-10 md:h-12" data-id="element-612" />
              </a>
              {/* Desktop Navigation - Inline with logo */}
              <nav className="hidden lg:flex space-x-1" data-id="element-613">
                <div className="relative" data-id="element-614">
                  <button className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium flex items-center" data-id="element-615">
                    <span data-id="element-616">Plan Your Journey</span>
                    <ChevronDownIcon size={16} className="ml-1" data-id="element-617" />
                  </button>
                </div>
                <div className="relative" data-id="element-618">
                  <button className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium flex items-center" data-id="element-619">
                    <span data-id="element-620">Trending Destinations</span>
                    <ChevronDownIcon size={16} className="ml-1" data-id="element-621" />
                  </button>
                </div>
                <div className="relative" data-id="element-622">
                  <button className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium flex items-center" data-id="element-623">
                    <span data-id="element-624">Deals</span>
                    <ChevronDownIcon size={16} className="ml-1" data-id="element-625" />
                  </button>
                </div>
                <div className="relative" data-id="element-626">
                  <button className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium flex items-center" data-id="element-627">
                    <span data-id="element-628">About Us</span>
                    <ChevronDownIcon size={16} className="ml-1" data-id="element-629" />
                  </button>
                </div>
                <div className="relative" data-id="element-630">
                  <button className="px-4 py-2 text-gray-700 hover:text-blue-600 font-medium flex items-center" data-id="element-631">
                    <span data-id="element-632">Our Brands</span>
                    <ChevronDownIcon size={16} className="ml-1" data-id="element-633" />
                  </button>
                </div>
              </nav>
            </div>
            {/* Right section: Actions */}
            <div className="flex items-center space-x-4" data-id="element-634">
              {/* Search toggle */}
              <button onClick={() => setSearchOpen(!searchOpen)} className="p-2 text-gray-600 hover:text-blue-600" aria-label="Search" data-id="element-635">
                <SearchIcon size={20} data-id="element-636" />
              </button>
              {/* Account button - desktop */}
              <a href="#" className="hidden md:flex px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 items-center" data-id="element-637">
                <UserIcon size={16} className="mr-2" data-id="element-638" />
                <span data-id="element-639">Account</span>
              </a>
              {/* Mobile profile icon */}
              <a href="#" className="p-2 text-gray-600 hover:text-blue-600 md:hidden" data-id="element-640">
                <UserIcon size={20} data-id="element-641" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Mega Navigation - Now controlled by the inline buttons */}
      <MegaNavigation data-id="element-642" />
      {/* Search overlay */}
      {searchOpen && <div className="absolute inset-0 bg-white z-40 p-4 pt-20" data-id="element-643">
          <div className="container mx-auto px-4" data-id="element-644">
            <div className="relative" data-id="element-645">
              <input type="text" placeholder="Search for destinations, tours, activities..." className="w-full p-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" autoFocus data-id="element-646" />
              <button onClick={() => setSearchOpen(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-647">
                <XIcon size={20} data-id="element-648" />
              </button>
            </div>
            <div className="mt-6" data-id="element-649">
              <h3 className="text-sm font-medium text-gray-500 mb-3" data-id="element-650">
                Popular Searches
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-651">
                <a href="#" className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800 hover:bg-gray-200" data-id="element-652">
                  Swiss Alps
                </a>
                <a href="#" className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800 hover:bg-gray-200" data-id="element-653">
                  Matterhorn
                </a>
                <a href="#" className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800 hover:bg-gray-200" data-id="element-654">
                  Zurich City Tour
                </a>
                <a href="#" className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800 hover:bg-gray-200" data-id="element-655">
                  Lake Geneva
                </a>
                <a href="#" className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800 hover:bg-gray-200" data-id="element-656">
                  Interlaken
                </a>
              </div>
            </div>
          </div>
        </div>}
      {/* Mobile menu */}
      <MobileNavigation isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} data-id="element-657" />
    </header>;
}